import ScheduleReminderAlert from "message-framework/components/ScheduleReminderAlert";
import LocationSettingsAlert from "message-framework/components/LocationSettingsAlert";
import AgentDownloadAlert from "app/common/alerts/AgentDownloadAlert";
import BasicMessage from "message-framework/components/BasicMessage";
import PatchScanSummaryAlert from "./components/PatchScanSummaryAlert";

export const componentRegistry = {
  AgentDownloadAlert,
  BasicMessage,
  ScheduleReminderAlert,
  LocationSettingsAlert,
  PatchScanSummaryAlert,
};
